/**
 * Site Backend Query API
 * # Summary Elisa B2B Online Sitebackend query-API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A single navigation link on the Ideat landing page, resolved from a linked ArticleCategory or ArticleTag entry.
 */
export interface IdeatHomepageLink { 
    /**
     * Display name of the linked category or tag.
     */
    label: string;
    /**
     * Slug of the category or tag, used to build the href client-side.
     */
    slug: string;
    /**
     * Whether this link points to a category or a tag collection page.
     */
    type: IdeatHomepageLink.TypeEnum;
}
export namespace IdeatHomepageLink {
    export type TypeEnum = 'category' | 'tag';
    export const TypeEnum = {
        category: 'category' as TypeEnum,
        tag: 'tag' as TypeEnum
    };
}


